import { render, staticRenderFns } from "./tableCampaignHistory.vue?vue&type=template&id=56827898"
import script from "./tableCampaignHistory.vue?vue&type=script&lang=js"
export * from "./tableCampaignHistory.vue?vue&type=script&lang=js"
import style0 from "./tableCampaignHistory.vue?vue&type=style&index=0&id=56827898&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports